import Header from "../components/Header"



const OurWorkPage = ()  => {

    return (
        <>
            <Header type="work"></Header>

        </>
    )
}


export default OurWorkPage